import { animate } from '~/animations';
import { publish } from '~/event-bus';
import { parseHTML, updateQueryParam } from '~/helpers';
import { HTMLCustomElement } from '~/html-custom-element';
import { ScrollTrigger } from 'gsap/scrolltrigger';

customElements.define(
  'main-product',
  class MainProduct extends HTMLCustomElement {
    connectedCallback() {
      if (super.connectedCallback) super.connectedCallback();

      this.on('option-change', this.targets.form, this.handleOptionChange.bind(this));

      this.on('updated', this.targets['gallery-section-part'], () => {
        const swiper = this.querySelector('swiper-container');
        const gallery = this.querySelector('product-gallery');

        if (swiper) {
          swiper.swiper.navigation.update();
        }

        if (gallery) {
          gallery.resetZoom();
        }
      });

      if (this.targets['child-product']) {
        if (!this.refreshed) {
          this.refresh(
            this.targets['child-product'].dataset.productHandle,
            this.targets['child-product'].dataset.productId,
          );
        }

        this.on('click', this.targets['child-product'].all, (event) => {
          this.refresh(event.target.dataset.productHandle, event.target.dataset.productId);
        });
      }
    }

    /**
     * Refreshes the section with the given product handle.
     *
     * @param {string} productHandle
     * @param {number} productId
     */
    refresh(productHandle, productId) {
      fetch(`/products/${productHandle}?section_id=${this.getAttribute('section-id')}`)
        .then((response) => response.text())
        .then((response) => {
          const element = parseHTML(response, this.tagName.toLowerCase());
          const reviews = document.getElementById('fulfilled-reviews-all');

          if (element) {
            element.refreshed = true;

            this.replaceWith(element);

            if (reviews) {
              const reviewsElement = document.createElement('div');

              reviewsElement.id = 'fulfilled-reviews-all';
              reviewsElement.dataset.id = productId;

              reviews.replaceWith(reviewsElement);
            }
          }
        });
    }

    /**
     * Handles the product form option change event.
     * @param {Object} event - The event payload.
     */
    async handleOptionChange(event) {
      try {
        const response = await this.getSectionByOptionValues(event.detail.values, event.detail.sellingPlan);
        const section = parseHTML(response, this.tagName.toLowerCase());

        publish('product-update', {
          sections: {
            [this.getAttribute('section-id')]: response,
          },
        });

        updateQueryParam('variant', section.getAttribute('selected-variant'));

        if (event.detail.sellingPlan) {
          updateQueryParam('selling_plan', event.detail.sellingPlan);
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            ScrollTrigger.refresh();
          });
        });
      } catch (error) {
        console.error(error);
      }
    }

    /**
     * Fetches and returns the updated section.
     * @param {String[]} values - The selected option values.
     * @returns {Promise<String>}
     */
    getSectionByOptionValues(values, sellingPlan = new URLSearchParams(window.location.search).get('selling_plan')) {
      return fetch(
        `${this.hasAttribute('product-handle') ? `/products/${this.getAttribute('product-handle')}` : window.location.pathname}?section_id=${this.getAttribute('section-id')}&option_values=${values.join(',')}${
          sellingPlan ? `&selling_plan=${sellingPlan}` : ''
        }`,
      ).then((response) => response.text());
    }
  },
);
